import React, { useCallback, useMemo } from "react";
import { Platform } from "react-native";
import { NativeStackNavigationProp } from "@react-navigation/native-stack";
import { graphql, useLazyLoadQuery } from "react-relay";
import { TeamHeaderDashboardButtonQuery } from "./__generated__/TeamHeaderDashboardButtonQuery.graphql";
import * as Haptic from "expo-haptics";
import { UserLoggedInNavigatorParamList } from "../../../../../TopLevelNavigators/UserLoggedIn/UserLoggedInNavigatorParamList";
import { TeamHeaderButton } from "./TeamHeaderButton";
import { ColorType } from "arkh";
import { useIntlTokens } from "../../../../../components/mobile/useIntlTokens";

export function TeamHeaderDashboardButton(props: {
  navigation: NativeStackNavigationProp<UserLoggedInNavigatorParamList>;
  openStorecastPicker(): void;
  tintColor: ColorType;
  compact?: boolean;
}) {
  const intl_tokens = useIntlTokens();
  const data = useLazyLoadQuery<TeamHeaderDashboardButtonQuery>(
    graphql`
      query TeamHeaderDashboardButtonQuery {
        store {
          dashboards {
            id
            name
          }
        }
      }
    `,
    {}
  );

  const dashboards = useMemo(
    () => data.store.dashboards.filter((dashboard) => !!dashboard),
    [data.store.dashboards]
  );

  const onPress = useCallback(() => {
    if (dashboards.length === 1) {
      const dashboard = dashboards[0];
      props.navigation.navigateDeprecated("Dashboard", {
        dashboardId: dashboard.id,
      });
    } else {
      props.openStorecastPicker();
    }
  }, [dashboards, props]);

  return dashboards.length === 0 ? null : (
    <TeamHeaderButton
      title={props.compact ? undefined : intl_tokens.Dashboards}
      icon="dashboard"
      spaceLeft={props.compact ? "small" : "medium"}
      spaceRight={props.compact ? "small" : "medium"}
      tintColor={props.tintColor}
      onPress={onPress}
      onPressIn={() => {
        if (Platform.OS === "ios") {
          Haptic.impactAsync(Haptic.ImpactFeedbackStyle.Light);
        }
      }}
    />
  );
}
